import { createContext } from 'react';
import { type AuthContextValue } from './types';

export const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  signIn: () => undefined,
  signOut: () => undefined,
  user: null,
  isLoading: true,
});
